var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overtime_search" }, [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "column",
          "align-items": "stretch",
          "flex-grow": "1",
          "flex-shrink": "1",
          height: "10px"
        }
      },
      [
        _vm.resultShowList.length
          ? _c(
              "div",
              {
                staticClass: "search_content",
                on: { scroll: _vm.handleScroll }
              },
              _vm._l(_vm.resultShowList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index + "search",
                    staticClass: "search_item",
                    on: {
                      click: function($event) {
                        return _vm.selectItem(item)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "select_ap" }, [
                      _vm.selectedArr.includes(item.id)
                        ? _c("i", {
                            staticClass: "kdfont kdfont-fuxuanxuanzhong"
                          })
                        : _c("i", {
                            staticClass:
                              "kdfont kdfont-fuxuankuangweixuanzhong_yuan"
                          })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "img_box" }, [
                      _c("img", {
                        attrs: {
                          src: item.headImg
                            ? item.headImg
                            : "images/pc/emotion/default_person_82_82.png?v=1.0",
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item" }, [
                      _c("div", {
                        staticClass: "person",
                        domProps: {
                          innerHTML: _vm._s(
                            item.personName
                              ? _vm.highlightHTML(item.personName)
                              : "--"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "department" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.adminorgName) +
                            "\n            "
                        ),
                        item.adminorgName && item.positionName
                          ? _c("span", { staticStyle: { margin: "0 2px" } }, [
                              _vm._v("·")
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n            " +
                            _vm._s(item.positionName) +
                            "\n            "
                        ),
                        !item.adminorgName && !item.positionName
                          ? _c("span", [_vm._v("--")])
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.resultShowList.length
          ? _c("div", { staticClass: "noData" }, [
              _c("img", { attrs: { src: _vm.noDataImgUrl, alt: "" } }),
              _c("span", [_vm._v("暂无数据")])
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "bottom_block" }, [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "align-items": "center",
            "font-size": "14px",
            color: "#666"
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "margin-right": "16px"
              },
              on: { click: _vm.selectAll }
            },
            [
              this.selectedArr.length === this.resultList.length
                ? _c("i", { staticClass: "kdfont kdfont-fuxuanxuanzhong" })
                : _c("i", {
                    staticClass: "kdfont kdfont-fuxuankuangweixuanzhong_yuan"
                  }),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "12px" } }, [
                _vm._v("全选")
              ])
            ]
          ),
          _vm._v(" "),
          _c("span", [_vm._v("已选")]),
          _c("span", { staticStyle: { margin: "0 4px" } }, [
            _vm._v(
              _vm._s(
                _vm.isClickSelectAllBtn
                  ? _vm.searchParam.totalNum -
                      (_vm.resultList.length - _vm.selectedArr.length)
                  : _vm.selectedArr.length
              )
            )
          ]),
          _c("span", [_vm._v("个")])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "submit",
          style: { background: _vm.selectedArr.length ? "#276FF5" : "#999" },
          on: { click: _vm.submit }
        },
        [_vm._v("确定")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }